import angular from 'angular';
import template from './forgotPasswordModal.html';

class ForgotPasswordModalController {
    constructor($scope, DataApiService) {
        'ngInject';
        this.$scope = $scope;
        this.DataApiService = DataApiService;
    }

    $onInit() {
        this.sentSuccess = false;
        this.sentError = false;

        this.closingEventListner = this.$scope.$on('modal.closing', (event) => {
            event.preventDefault();

            this.closingEventListner();
            this.sentSuccess? this.close() : this.dismiss();
        });
    }

    $onChanges(changes) {
        if (changes.resolve) {
            let {email} = this.resolve;
            this.email = email;
        }
    }

    $onDestroy() {
        if (this.closingEventListner) this.closingEventListner();
    }

    submitEmail(email) {
        this.DataApiService.forgotPassword(email)
            .then(() => {
                this.sentSuccess = true;
                this.sentError = false;
            })
            .catch(() => {
                this.sentSuccess = false;
                this.sentError = true;
            });
    }

}

export const ForgotPasswordModalComponent = {
    name: 'mmsForgotPasswordModal',
    component: {
        template: template,
        controller: ForgotPasswordModalController,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/common/forgotPwModal/forgotPasswordModal.component.js